import React from "react";
import TodoList from "./component/Basics/Todo";

function App(){

  return (
    <TodoList></TodoList>
  )
}

export default App;
